import axios from "../../config/axiosConfig";
import {
  GSTDETAIL_REPORT_REQUEST,
  GSTDETAIL_REPORT_SUCCESS,
  GSTDETAIL_REPORT_FAILURE,
} from "../types/gst-detail-report-types";

export const getGSTDetailReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GSTDETAIL_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
    
      const requestParams = { ...defaultParams, ...params };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/gstdetail-report/getReport?${queryString}`;
      console.log('Complete GSTDETAIL API Request URL: ', fullUrl);
      return axios.get('/gstdetail-report/getReport', { params: requestParams }).then((response) => {
        if (response) {
          dispatch({ 
            type: GSTDETAIL_REPORT_SUCCESS, 
            payload: response 
          });
          console.log("Actions Api Call" , response);
          
          return response;
        } else {
          throw new Error(response.data?.message || 'Failed to fetch GSTR2 report');
        }
      }).catch((error) => {
        console.error("Error fetching GSTDETAIL Report:", error);
        dispatch({ 
          type: GSTDETAIL_REPORT_FAILURE, 
          error: error.response?.data?.message || error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GSTDETAIL Report:", error);
      dispatch({ 
        type: GSTDETAIL_REPORT_FAILURE, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  };
};
